import { Alert, CircularProgress, LinearProgress } from "@mui/material";
import * as React from "react";

interface LoadingWrapperProps {
    loading: boolean;
    showText?: boolean;
    classes?: any;
    hideWhenLoading?: boolean;
    linear?: boolean;
    error?: null | string;
}

export class LoadingWrapper extends React.Component<LoadingWrapperProps, {}> {

    constructor(props) {
        super(props);
    }

    renderChildren() {
        if (this.props.error) {
            return <div style={{ padding: "5px 10px" }}>
                <Alert severity="error">{this.props.error}</Alert>
            </div>;
        }

        if (!this.props.hideWhenLoading) {
            return this.props.children;
        }

        if (this.props.loading) {
            return null;
        }

        return this.props.children;
    }

    render() {
        const { loading } = this.props;

        return <div className="loading--wrapper">
            {loading && <div className="loading--icon">
                {!this.props.linear && <CircularProgress style={{ margin: 16 }}/>}
                {this.props.linear && <LinearProgress/>}
            </div>}

            {this.renderChildren()}
        </div>;
    }
}
